import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getWebViewHtml } from '../../action/webViewContentAction.js';
import './ModalSelect.css';

class ModalSelectTip extends Component {
  static defaultProps = {
    leftButtonTitle:　'取消',
    rightButtonTitle:'确认',
    content:'',
    contentBC:'',
    onCancel:()=>{},
    onOK:()=>{},
    titleBC:'',
    title:'',
    flag:false,
  }
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }
  componentWillMount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","overflow:hidden")
  }
  componentWillUnmount(){
    // document.getElementsByTagName('body')[0].setAttribute("style","")
  }
  render(){
    return (
      <div>
        {this.props.flag?<div  className='containerModal' >
          <div className='modalView'>
            <div className='titleText'style = {{marginTop: this.props.titleBC ? 6 : 20}}>{this.props.title}
            </div>
            <div className='contentText' >
              {
                this.props.content?this.props.content:
                <div>
                  <p>本基金投资顾问服务及基金销售服务由上海华夏财富投资管理公司（以下简称华夏财富）提供。</p>
                  <p>华夏财富为华夏基金全资子公司，拥有证监会颁发的基金销售资格，2019年10月首批获得证监会批准试点开展基金投资顾问业务。</p>
                  <p>基金投资顾问为华夏财富接受投资者委托，按照约定向投资者提供的根据投资者个人情况，提供投资建议并构建投资组合及投资交易的投资顾问服务工具，其实质为投资特定投资组合所包含的公募基金产品或经中国证监会认可的同类产品。</p>
                  <p>基金投资顾问服务有包括但不限于以下特点：</p>
                  <p>1、 在符合相关业务规范及合规操作的前提下，组合由专业资产配置团队，<span style={{color:'#fa063a'}}>根据市场行情与组合表现情况进行自动调仓</span>，投资者可在有关信息披露中查询。</p>
                  <p>2、 依据相关法律法规及《基金投资顾问服务协议》等文件的规定，根据投资者委托向其提供管理型基金投资顾问服务，<span style={{color:'#fa063a'}}>有权向投资者收取投资顾问服务费</span>。</p>
                  <p>请投资者务必于申请使用基金投资顾问服务之前，仔细阅读《基金投资顾问服务协议》、华夏财富交易平台相关的业务规则及风险揭示书，充分了解基金投资顾问业务规则、收费方式、免责情形、一般及特有风险等内容。</p>
                </div>
              }
            </div>
            <div className='contentTwoText' >
            {
              this.props.contentBC?this.props.contentBC:
                <p>风险提示：本公司承诺以诚实信用、勤勉尽责的原则提供基金投资顾问服务，提供投资建议并为投资者调仓，但不保证投顾账户一定盈利，投资者需自行承担投资风险。基金投资组合策略的风险特征与单只基金产品的风险特征存在差异，组合过往业绩不代表未来表现，为其他客户创造的收益并不构成业绩表现的保证。</p>
            }

            </div>
            <div className='footView' style={{bottom:document.documentElement.clientHeight/2 - 550/2}}>
              <p onClick={()=>this.props.onOK()}>{this.props.rightButtonTitle}</p>
            </div>
          </div>
        </div>:null
      }
      </div>
    );
  }
}


export default ModalSelectTip



// WEBPACK FOOTER //
// ./src/components/Modal/ModalSelectTip.js